module.exports = __webpack_public_path__ + "img/sintesis.928edff2.svg";